import axios from '../../axios'
import store from "../store";

export default {
  async setRol({ commit }, rol) {
    let {data} = await axios.post('/auth/newRole',rol)
    await store.dispatch('lists/getListRol');
    await store.dispatch('lists/getListMenu');
  },
  async updateRol({ commit }, rol) {
    let {data} = await axios.post('/auth/editRole',rol)
    commit('trash_rol')
    await store.dispatch('lists/getListRol');
  },
}
